import { gql } from "@apollo/client";

export const GET_USER_NOTIFICATIONS_HISTORY = gql`
  query getUserNotificationsHistory($daysBack: Int) {
    getUserNotificationsHistory(daysBack: $daysBack) {
      _id
      title
      body
      read
      type
      createdAt
      listing {
        _id
        streetAddr
        city
        state
        zip
        price
        user {
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_SENT_NOTIFICATIONS = gql`
  query getSentNotifications($companyId: String, $daysBack: Int) {
    getSentNotifications(companyId: $companyId, daysBack: $daysBack) {
      _id
      title
      body
      type
      recipientType
      recipientLabel
      recipientNames
      recipientCount
      deliveredCount
      failedCount
      pendingCount
      status
      createdAt
      scheduledAt
    }
  }
`;
